/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseProjectDtoPage } from '../../models/base-project-dto-page';
import { ProjectStatus } from '../../models/project-status';

export interface ListProjects$Params {
  name?: string;
  isArchived?: boolean | null;
  isPublic?: boolean | null;
  isTemplate?: boolean | null;
  createdById?: string | null;
  laborCostIds?: Array<string>;
  projectStatuses?: Array<ProjectStatus>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'code' | '-code' | 'name' | '-name' | 'isTemplate' | '-isTemplate' | 'templateId' | '-templateId' | 'revenueEnabled' | '-revenueEnabled' | 'cashFlowEnabled' | '-cashFlowEnabled' | 'costFlowEnabled' | '-costFlowEnabled' | 'budgetEnabled' | '-budgetEnabled' | 'allowMultipleBudget' | '-allowMultipleBudget' | 'allowBudgetCapOvercome' | '-allowBudgetCapOvercome' | 'allowEstimatesOvercome' | '-allowEstimatesOvercome' | 'allowNotAllocatedEffectives' | '-allowNotAllocatedEffectives' | 'allowUpdateBudgetVersionEstimates' | '-allowUpdateBudgetVersionEstimates' | 'allowUpdateActiveBudget' | '-allowUpdateActiveBudget' | 'workPackageEstimates' | '-workPackageEstimates' | 'personEstimates' | '-personEstimates' | 'description' | '-description' | 'completionPercentage' | '-completionPercentage' | 'status' | '-status' | 'createdBy' | '-createdBy' | 'projectStatusDescription' | '-projectStatusDescription' | 'customFields' | '-customFields' | 'isPublic' | '-isPublic' | 'isArchived' | '-isArchived' | 'customFieldsValue' | '-customFieldsValue' | 'startDate' | '-startDate' | 'endDate' | '-endDate' | 'workPackagesCount' | '-workPackagesCount' | 'expiredWorkPackagesCount' | '-expiredWorkPackagesCount' | 'budgetsCount' | '-budgetsCount' | 'usersCount' | '-usersCount' | 'currentBudgetsVersion' | '-currentBudgetsVersion' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listProjects(http: HttpClient, rootUrl: string, params?: ListProjects$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseProjectDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listProjects.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('isArchived', params.isArchived, {});
    rb.query('isPublic', params.isPublic, {});
    rb.query('isTemplate', params.isTemplate, {});
    rb.query('createdById', params.createdById, {});
    rb.query('laborCostIds', params.laborCostIds, {});
    rb.query('projectStatuses', params.projectStatuses, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseProjectDtoPage>;
    })
  );
}

listProjects.PATH = '/v0/projects';
